// реально any
/* eslint-disable @typescript-eslint/no-explicit-any */
export function noopReducer() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (state) {
    return state || defaults;
  };
}